<template>
  <div class="animated fadeIn">     
    <b-row>
      <b-col md="12">
<!--          <b-breadcrumb :items="breadcrumbs"/>       
 -->        <b-card>
          <div slot="header">
            <strong> Admin user</strong>
            <div class="card-header-actions" >                
              <button class="btn btn-sm btn-primary mr-4 btn-pill" v-on:click="useradd()"  type="button">Add New</button>
               <button class="btn btn-sm btn-primary ml-4" v-on:click="refresh()" type="button"><i class="fa fa-refresh"></i></button>
            </div>
          </div>

             <div id="overlay">
              <div class="loader"></div>
            </div>
              <div
                  id="adduser"
                  v-show="showAddUser"
                  style="padding: .75rem 1.25rem;border: 1px solid rgba(0,0,0,.125);"
                  class="mb-1"
                >
              <b-form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
               <input type="hidden" name="chkEditVal" id="chkEditVal" value="0">
                <b-row>
                  <b-input-group class="mb-3">
                   <b-form-radio-group
                      v-model="customer.selectedhubtype"
                      name="selectedhubtype"
                      :options="hubTypeOptions"
                      class="input"
                      @change="gethublist"
                    >
                    </b-form-radio-group>
                  </b-input-group>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="pickuplocationmasterid">Hub</label>
                      
                      <!-- {{/* v-if="currenthubidselct!=hub.pickuplocationmasterid" */}} -->
                      <b-form-select @change="getcountries(customer.pickuplocationmasterid)" v-model="customer.pickuplocationmasterid" name="pickuplocationmasterid" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.pickuplocationmasterid') }">
                        <option value="">--Select--</option>
                        <option v-for="hub in hublist"  v-bind:value="hub.pickuplocationmasterid">{{hub.pickuplocationname}}</option>
                    </b-form-select> 
                    </b-form-group>
                  </b-col>
                  
                  <b-col sm="3">
                    <b-form-group>
                      <label for="sysemailid">Email id</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="sysemailid" v-model="customer.sysemailid" v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-1.sysemailid') }" placeholder="Enter Email id">
                        </b-form-input>
                      </b-input-group>
                     
                      </b-form-group>
                  </b-col>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="first name">First Name</label>
                      <b-form-input type="text" name="first name" v-model="customer.userfirstname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.first name') }" placeholder="Enter First Name">                       
                       </b-form-input>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('first name')" ></i>
                      </span>
                      <span style="width:240px" v-show="errors.has('form-1.first name')" class="help text-danger">{{ errors.first('form-1.first name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="last name">Last Name</label>
                      <b-input-group class="mb-3">                     
                        <b-form-input class="input" type="text" name="last name" v-model="customer.userlastname" v-validate="'required|alpha|min:3|max:30'" :class="{'input': true, 'text-danger': errors.has('form-1.last name') }" placeholder="Enter Last Name">
                        </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('last name')" ></i>
                      </span>
                         <span style="width:240px" v-show="errors.has('form-1.last name')" class="help text-danger">{{ errors.first('form-1.last name') }}</span>
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                  
                </b-row>
                <b-row>
                  <b-col sm="3">
                    <b-form-group>
                      <label for="usermobilenumber">Mobile Number</label>
                      <b-input-group class="mb-3">
                          <b-form-input class="input" type="text" id="usermobilenumber" name="mobile number" maxlength="10" v-model="customer.usermobilenumber" v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-1.mobile number') }" placeholder="Enter Mobile Number" >
                          </b-form-input>  
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('mobile number')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.mobile number')" id="addmblnbrmsg" class="help text-danger">{{ errors.first('form-1.mobile number') }}
                      </code>
                      </b-input-group>
                      </b-form-group>
                  </b-col>

                  <b-col sm="3">
                    <b-form-group>
                      <label for="Password">Password</label>
                      <b-input-group class="mb-3">
                         <b-form-input class="input" type="password" name="syspassword" minlength="6" maxlength="14" v-model="customer.syspassword" v-validate="'required|'" :class="{'input': true, 'text-danger': errors.has('form-1.syspassword') }" placeholder="Enter Password">
                         </b-form-input>
                      </b-input-group>
                      <b-input-group class="mb-3">
                      <span class="icon has-text-warning">
                        <i class="fa fa-warning" v-show="errors.has('syspassword')" ></i>
                      </span>
                      <code v-show="errors.has('form-1.syspassword')" id="passwordtxt" class="help text-danger">{{ errors.first('form-1.syspassword') }}
                      </code>                      
                      </b-input-group>
                      </b-form-group>
                  </b-col>
                 
                  <b-col sm="3">
                      <b-form-group>
                        <label for="status">Status</label>
                        <b-input-group class="mb-3">
                          <b-form-select v-model="customer.isactive" name="status" v-validate="'required|'" :class="{'input': true, 'is-invalid': errors.has('form-1.status') }">
                          <option value="">--Select--</option>
                          <option value="1">Active</option>
                          <option value="0">InActive</option>
                        </b-form-select>
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('status')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.status')" id="statustxt" class="help text-danger">{{ errors.first('form-1.status') }}
                        </code>
                        </b-input-group>
                        </b-form-group>
                  </b-col>
                  <b-col sm="3">
                      <b-form-group>
                        <label for="usertype">User Type</label>
                        <b-input-group class="mb-3">
                          <b-form-select name="usertype" v-model="customer.usertype" v-validate="'required|'" :class="{'input': true, 'usertype': errors.has('form-1.usertype') }">
                          <option value="0">Normal</option>
                          <option value="1">Privilage</option>
                           <option value="2">Warehouse</option>                          
                        </b-form-select>
                        
                        </b-input-group>
                        <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('usertype')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.usertype')" id="usertype" class="help text-danger">{{ errors.first('form-1.usertype') }}
                        </code>
                        </b-input-group>
                        </b-form-group>
                  </b-col>

                  <!-- Nazafat Addition -->
                  <b-col sm="3">
                     <b-form-group >  
                      <label for="countrycode">Hub Country</label> 
                    <b-form-select v-model="customer.countrycode" name="countrycode" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.locationpincode') }">
                        <option :value="selected">--Select--</option>
                        <option v-for="country in countries"  v-bind:value="country.country">{{country.country}}</option>
                    </b-form-select> 

                    
                   <!--  <span style="text-align:left;" v-show="errors.has('form-1.location pincode')" class="help text-danger">{{ errors.first('form-1.pickup location code') }}</span>   -->   

                    <b-input-group class="mb-3">
                        <span class="icon has-text-warning">
                          <i class="fa fa-warning" v-show="errors.has('countrycode')" ></i>
                        </span>
                        <code v-show="errors.has('form-1.countrycode')" id="countrycode" class="help text-danger">{{ errors.first('form-1.countrycode') }}
                        </code>
                        </b-input-group>   
                  </b-form-group>




                  </b-col>




                </b-row>
                <footer class="column has-text-right">
                <b-button variant="primary" size="md" type="submit">Save</b-button>
                </footer>
              </b-form>
            </div>
               <b-row>
             <b-col md="3" class="my-1">
                <b-form-group label-cols-sm="3" label="Filter" class="mb-0">
                  <b-input-group>
                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            


          <b-table show-empty stacked="md"  :items="items" :busy="isBusy"    :current-page="currentPage"  :fields="fields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 

            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
            </div>  
            <template slot="email" slot-scope="row">
              <p>{{ row.item.sysemailid }} <span data-toggle="tooltip" title="InActive" v-if="row.item.is_qwik_user =='yes'" > 
                  <span class="badge badge-success">QWIK</span>
                </span>  </p>
               
            </template>
             <template slot="actions" slot-scope="row">
             <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                     Delivery Boy
              </b-button>
            </template>
             <template slot="usertypeaction" slot-scope="row">
             {{row.item.user_type == 0 ? 'Normal ' : row.item.user_type == 1 ? 'Privilage':'Warehouse'}}
            </template>
          

          <!--  <template slot="isactive" slot-scope="row">
             <span data-toggle="tooltip" title="InActive" v-if="row.value.isactive ==='0'" style="color:red"> <i class="badge badge-success">In Active</i></span>
            <span data-toggle="tooltip" title="Active" v-else style="color:green"><i class="badge badge-success">Active</i></span>
            </template> -->
             <template slot="isactive" slot-scope="row">
                  <span  @click="toggleInfoModal(row.item)" style="cursor:pointer;">
                  <span data-toggle="tooltip" title="InActive" v-if="row.item.isactive ==='0'" > 
                    <span class="badge badge-danger">Inative</span>
                  </span>  
                  <span data-toggle="tooltip" title="Active" v-else >
                    <span class="badge badge-success">Active</span>
                  </span>
                  </span>
                </template>
              


              <template slot="action" slot-scope="row">
                <b-button size="sm" title="Change Password" @click="editAdminPasswordModal(row.item)" class="mr-1" v-if="country == 'KSA' && (sysusermasterid == 29 || sysusermasterid == 57)">
                  <i class="fa fa-key" ></i>
                </b-button>
             <b-button size="sm" @click="editinfoModal(row.item)"  data-toggle="tooltip" title="Update Admin  Info"  class="mr-1" style="background: #b0c4de !important;color: #000 !important;">
                    Edit
                  </b-button>
          <!-- <router-link
            :to="'/access/'+row.item.sysusermasterid"
          > -->
            <router-link 
              :to="{
                path: `/access/${row.item.sysusermasterid}`,
                query: { 
                  is_qwik_user: row.item.is_qwik_user
                }
              }"
            >
           <button class="btn btn-sm "   type="button" style="background: #b0c4de !important;color: #000 !important;">Assign Access</button> </router-link>

           <router-link 
              :to="{
                path: `/pdaaccess/${row.item.sysusermasterid}`,
                query: { 
                  is_qwik_user: row.item.is_qwik_user
                }
              }"
            >
           <button v-if="row.item.is_qwik_user == 'no'" class="btn btn-sm ml-2"   type="button" style="background: #b0c4de !important;color: #000 !important;">PDA Access</button> </router-link>
     
            </template>
          </b-table>
            <b-modal title="Confirmation Box" v-model="toggleInfo" size="md" @ok="toggleInfo = false">
        <template slot="modal-header" slot-scope="{ close }">
        <h5>Confirmation Box</h5>
        </template>
        
        <template slot="default" slot-scope="{ hide }">
          <form v-on:submit.prevent="activateInActivateDeliveryAgent()">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <input type="hidden" v-model="customer.isactive" name="isactive" id="modalIsActiveChk">
                <span>Are you sure you want to change the status?</span>
              </section>
              <footer >
                <b-button variant="primary" size="sm" type="submit">Ok</b-button>
              </footer>
            </div>
          </form>
        </template>
      
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
           <b-modal title="Update Admin  Info" v-model="editAgentMaster" @ok="editAgentMaster = false">
          <template slot="modal-header" slot-scope="{ close }">
          <h5>Update Admin User  Info</h5>
          </template>
          <template slot="default" slot-scope="{ hide }">
             <b-form @submit.prevent="validateForm5('form-5')" data-vv-scope="form-5">

            
                
                
                           <b-form-group
                  label="Email ID"
                  :label-cols="3"
                  >                      
                    <b-form-input class="input" type="text" v-model="customer.email_id" name="email_id"  v-validate="'required|email'" :class="{'input': true, 'text-danger': errors.has('form-5.email_id') }" placeholder="Enter  Email ID">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.email_id')" class="help text-danger">{{ errors.first('form-5.email_id') }}</span>
                  
                </b-form-group>
                

                 <b-form-group
                  label="First Name"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.first_name" name="first_name"  v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-5.first_name') }" placeholder="Enter First Name">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.first_name')" class="help text-danger">{{ errors.first('form-5.first_name') }}</span>
                </b-form-group>

                <b-form-group
                  label="Last Name"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.last_name" name="last_name"  v-validate="'required|alpha_spaces'" :class="{'input': true, 'text-danger': errors.has('form-5.first_name') }" placeholder="Enter Last Name">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.last_name')" class="help text-danger">{{ errors.first('form-5.last_name') }}</span>
                </b-form-group>

               <!--    <b-form-group
                  label="Mobile Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.mobile_no" name="mobile_no"  v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.mobile_no') }" placeholder="Enter Mobile Number ">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.mobile_no')" class="help text-danger">{{ errors.first('form-5.mobile_no') }}</span>
                </b-form-group>
 -->


                  <b-form-group
                  label="Mobile Number"
                  :label-cols="3"
                  >                      
                   <b-form-input class="input" type="text" v-model="customer.mobile_no" name="mobile_no"  v-validate="'required|digits:10'" :class="{'input': true, 'text-danger': errors.has('form-5.mobile_no') }" placeholder="Enter Mobile Number ">             
                  </b-form-input>
                  <span style="width:100px" v-show="errors.has('form-5.mobile_no')" class="help text-danger">{{ errors.first('form-5.mobile_no') }}</span>
                </b-form-group>


                      <b-form-group label="User Type" :label-cols="3">
                       
                        
                          <b-form-select v-model="customer.editusertype" name="editusertype"  :class="{'input': true, 'is-invalid': errors.has('form-5.status') }">
                          <option value="">Select</option>
                          <option value="0">Normal</option>
                          <option value="1">Privilage</option>
                          <option value="2">Warehouse</option>

                        </b-form-select>
                        <span style="width:100px" v-show="errors.has('form-5.editusertype')" class="help text-danger">{{ errors.first('form-5.editusertype') }}</span>
                       
                      </b-form-group>
                 
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="sm" class="mr-4" variant="primary"> Update</b-button>
                  <b-button  size="sm" variant="danger" @click="editcancel()">cancel</b-button>
                </div>
              </b-form>
          </template>
          <template slot="modal-footer" slot-scope="{ hide }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" style="display:none">
              Cancel
            </b-button>
            <!-- Button with custom close trigger value -->
          </template>
      </b-modal> 

          <b-col md="12" class="my-1 " v-if="this.totalRows > 10">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
              ></b-pagination>
          </b-col>    
        </b-card>
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
      </b-modal>

      <!-- Password change Option  -->
      <b-modal  title="Change Password" size="md" v-model="editAgentMastertoggleInfo" @ok="editAgentMastertoggleInfo = false" hide-footer>
       <!--  <template slot="modal-header" slot-scope="{ close }">
        <h5>Change Password</h5>
        </template> -->
        <template slot="default" slot-scope="{ hide }">
          <form @submit.prevent="validateForm4('form-4')" data-vv-scope="form-4">
            <div class="modal-background"></div>
            <div class="modal-card">
              <section class="modal-card-body">
                <div class="field">
                  <p class="control">
                     <span style="color: red;">Strong Passowrd Rules:<br>

                    1)Your password must be between 6 to 30 character<br>
                    2)Password must contain at least one lowercase and uppercase character<br>
                    3)Password must contain at least one number<br>
                    4)Password must contain at least one special character <br>
                    </span>
                    <b-form-input class="input" type="text" name="password" minlength="6" maxlength="14" v-model="customer.password" v-validate="{ required: true, regex:/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,12})/ }" :class="{'input': true, 'text-danger': errors.has('form-4.password') }"
                      placeholder="Enter password" />
                    <code v-show="errors.has('form-4.password')" class="help text-danger">{{ errors.first('form-4.password') }}</code>
                  </p>
                </div>
              </section>
              <footer class="text-right">
                <b-button size="sm" variant="primary" type="submit" class="mr-4">Update</b-button>
                 <b-button size="sm" variant="danger" @click="cancel()" >
            Cancel
          </b-button>
              </footer>
            </div>
          </form>
        </template>
        <template slot="modal-footer" slot-scope="{ cancel }">
          <!-- Emulate built in modal footer ok and cancel button actions -->
          <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
            Cancel
          </b-button>
          <!-- Button with custom close trigger value -->
        </template>
      </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import Vue from 'vue'
export default {
  name: 'adminuser_mr', 
  data: function() {
    return {
      name: 'adminuser_mr',
      isBusy: false,
      breadcrumbs: [{
        text: 'Dashboard',
        href: '/dashboard'
      },{
        text: 'Admin user',
        active: true
      }],
      data: [],
      clientdata: [],
      add: true,          
      customer: {usertype:0,
         selectedhubtype:'normal'
       },
      items:[],
      hublist: [],
      usertype:[],
      fields: [
          { key: 'pickuplocationmasterid', label: 'Hub ID', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationname', label: 'Hub Name', sortable: true, sortDirection: 'desc' },
          { key: 'email', label: 'Email ID', sortable: true},
          // { key: 'syspassword', label: 'Password', sortable: true},
          { key: 'countrycode', label: 'Country Code', sortable: true},
          { key: 'userfirstname', label: 'First Name', sortable: true},          
          { key: 'userlastname', label: 'Last Name', sortable: true },    
          { key: 'usermobilenumber', label: 'mobilenumber', sortable: true },
          { key: 'usertypeaction', label: 'User Type', sortable: true },
          { key: 'isactive', label: ' status' },
          { key: 'action', label: ' Actions' },
        
       ], 
        bordered: true,
         // filter: null,
        totalRows: 0,
        countries:[],
        selected:'',
        toggleInfo: false,
        currentPage: 1,
        perPage:  10,
        pageOptions: [5, 10, 15],
        sortBy: null,
        sortDesc: false,
        editAgentMaster:false,
        sortDirection: 'asc',
        filter: null,
        currenthubidselct:'',
        // hublistid:[],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        userCountry:null,

        // password change option
        editAgentMastertoggleInfo: false,
        sysusermasterid:null,
        country : null,
        // customer: {},
        showAddUser: false,
       quickdashbaordid:'',
    }
  },
  created: function() {
    //alert("testing build");
     if (this.$route.params.id === 'quick_dashboard') {
        this.customer.selectedhubtype = 'quick';
         this.gethublist(this.customer.selectedhubtype);
      }
    else{
      this.gethublist();
    }
    
    this.displaydata();
    // this.getcountries();
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    // console.log(userInfo);
    this.userCountry = localStorage.getItem('country')
    this.currenthubidselct=userInfo.pickuplocationmasterid.toString();
    this.sysusermasterid = userInfo.sysusermasterid;
    this.country = userInfo.country;
    this.customer.syspassword ='';
    this.customer.isactive ='';
    this.customer.usertype ='';
    this.customer.countrycode ='';
    this.customer.pickuplocationmasterid ='';
    this.customer.sysemailid ='';
    this.customer.userfirstname ='';
    this.customer.userlastname ='';

  },

  computed: {
    hubTypeOptions() {
      if (this.$route.params.id === 'quick_dashboard') {
        return [
          { text: 'Quick', value: 'quick' }
        ];
      }

      return [
        { text: 'Normal', value: 'normal' },
       
      ];
    }
  },
  
  methods: {

    info(item, index, button) {
        this.infoModal.title = `Row index: ${index}`
        this.infoModal.content = JSON.stringify(item, null, 2)
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
      },
    gethublist: function(value){
      console.log(value)
        var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      // alert(userInfo.pickuplocationmasterid);

      const obj = {
        hub_id:`${userInfo.pickuplocationmasterid}`,
         selectedhubtype: value
      };
      // console.log("obj",obj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/gethublist`,obj)
        .then(result => {
          // console.log(result);
          if(result.body.returnmsg=='Successful'){
          this.hublist = result.body.returnvalue;
          // console.log("Hublist",this.hublist);
        //   for(var i=0;i<=this.hublist.length;i++){
        //   this.hublistid=result.body.returnvalue[i].pickuplocationmasterid;
        //   console.log("hublistid",this.hublistid);
        // }
          }
          else{
            this.hublist=[]
          }
          // console.log('this.gethublist',this.hublist);
        })
        .catch(ex => {
          alert('error-----',ex);
        });
    },   

    // Nazafat Addition
      getcountries: function(value){
        // alert(value);
         var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
         const obj = {
        // hub_id:`${userInfo.pickuplocationmasterid}`,
          // hub_id:this.hublistid,
          hub_id:value
      };
         // console.log("Countryobj",obj);
      this.$http
        .post(`${CONSTANTS.MIGRATION_API_URL}/getadminusercountrylist`,obj)
        .then(result => {
          this.countries = result.body.returnvalue;
          // console.log('this.locations',this.countries);
        })
        .catch(ex => {
          alert(ex);
        });
    },




    validateForm(scope) {
       this.$validator.validateAll(scope).then(result => {
        if (result) {          
          this.addAdminInfo();
        }
      });
    },
    clear1: function() {},
    useradd: function() {
      //this.customer = {};
      this.subtitle='Add Users';
      this.errors.clear("form-1");
   
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      // var adduser = document.getElementById("adduser");
      // adduser.style.display = "block";
      this.showAddUser = true;
    
    },
      editinfoModal: function(value) {
     
       // alert(value.userfirstname);      
     
     this.sysusermasterid=value.sysusermasterid
       
      

      this.customer.hub_name =value.pickuplocationmasterid;
      this.customer.email_id =value.sysemailid;
      this.customer.first_name = value.userfirstname;
      
      this.customer.last_name = value.userlastname; 
      this.customer.editusertype = value.user_type; 
      
      this.customer.mobile_no = value.usermobilenumber;
          
      this.editAgentMaster = !this.editAgentMaster;
  
    },
       editcancel: function() {
      this.customer = {};
      this.editAgentMaster = !this.editAgentMaster;
    },
    validateForm5(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
           this.updateAdinAgent();
        }
      });
    },
  
     updateAdinAgent: function() {
     
      var result = [];
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
     
      
     
      var passwObj = {
        sysemailid: this.customer.email_id,
        userfirstname:this.customer.first_name,
        userlastname: this.customer.last_name,
        user_type:this.customer.editusertype,
        
        usermobilenumber:this.customer.mobile_no,
        sysusermasterid: this.sysusermasterid,
         hub_id:`${userInfo.pickuplocationmasterid}`,
       
          
      };  
      // console.log("Obj",passwObj);
     
      
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/editadminuser`,
            passwObj).then(result => {
               // console.log("result",result);
     
           if (result.body.returmmsg === "Successful") {
            alert("Updated Successfully");
            // this.$fire({
            //       text: "Updated Successfully",
            //       type: "success",
            //       timer: 30000
            //     }); 
            this.editAgentMaster = !this.editAgentMaster;
            this.customer = {};
            this.displaydata();
          }
          else
          {
            // Utils.notify(result.body.returnvalue, "error");
             // this.$fire({
             //      text:result.body.returnvalue,
             //      type: "error",
             //      timer: 30000
             //    }); 
           alert(result.body.returnvalue);
          }
          })
          .catch(ex => {
            console.log("error", ex);
          });
      
    }, 
    toggleInfoModal: function(value) {
      this.adminactive=value.isactive  
      // console.log( this.adminactive);
      this.sysusermasteridvalue=value.sysusermasterid;
      this.toggleInfo = !this.toggleInfo;
    },

 activateInActivateDeliveryAgent: function() {
   // console.log( this.adminactive);
  
      var activeInactiveVal;
      if (this.adminactive === "1") {
        activeInactiveVal = "0";
      } else {
        activeInactiveVal = "1";
      }
      // console.log(activeInactiveVal);
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const customerGetobj = {
        sysusermasterid:`${this.sysusermasteridvalue}`,
        isactive: activeInactiveVal,
        lastmodifiedby: `${userInfo.sysemailid}`,
         // hub_id:`${userInfo.pickuplocationmasterid}`,
      };

      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/activateinactivateadminuser`,
          customerGetobj
        )
        .then(result => {
          // console.log("Result",result);
          if(result.body.returnmsg ==="Unsuccessful")
          {
            Utils.notify(result.body.returnvalue, "error");
            // this.$fire({
            //       text:result.body.returnvalue,
            //       type: "error",
            //       timer: 30000
            //     }); 
              this.toggleInfo = false;
         //this.displaydata();
         
        }
        else
        {
        alert("Status Changed Successfully");
        // this.$fire({
        //           text:"Status Changed Successfully",
        //           type: "success",
        //           timer: 30000
        //         }); 
        this.displaydata();
        this.toggleInfo = false;
         
        }
        })
        .catch(ex => {
          console.log("error", ex);
        });
    //  this.displaydata();
     // alert("Status changed successfully");
    }, 
    refresh:function() {
       this.subtitle='Users';
     
      // var allocatepin = document.getElementById('allocatepin')
      // allocatepin.style.display = 'none'
      // var adduser = document.getElementById("adduser");
      // adduser.style.display = "none";
      this.showAddUser = false;
      this.searchclear();
    },
    chkmobileVal() {
      var chkValidate = true;
     // var chknumb = /^[789]{1}\d{9}$/
      var chknumb = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
      var usermobilenumber = document.getElementById("usermobilenumber").value
      if (usermobilenumber.trim() === '0000000000' || usermobilenumber.trim().length < 10) {
        chkValidate = false
        return false
      } else if (usermobilenumber.trim() != "" && !(usermobilenumber.trim().match(chknumb))) {
        chkValidate = false
        return false
      }
      return chkValidate = chkValidate;
    },
    displaydata: function () {

      this.isBusy = true;

      var userdata = localStorage.getItem('userData');
      var userInfo = JSON.parse(userdata);

      const obj = {
        hub_id: `${userInfo.pickuplocationmasterid}`,
      };

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getsystemuserlist`, obj)
        .then((result) => {

          if (result.body.returnmsg === 'Successful') {

            let data = result.body.returnvalue;

            // Show only qwik users on quick dashboard
            if (this.$route.params.id === 'quick_dashboard') {
              data = data.filter(item => item.is_qwik_user === 'yes');
            }
            else{
               data = data.filter(item => item.is_qwik_user === 'no');
            }

            this.data = data;
            this.items = data;
            this.totalRows = data.length;
            this.isBusy = false;

          } else {
            alert('No Records Found');
            this.isBusy = false;
          }
        })
        .catch((ex) => {
          console.log('error-----', ex);
          this.isBusy = false;
        });
    },
    addAdminInfo: function() {
      

       document.getElementById("overlay").style.display = "block";

      // const obj = {
      //   pickuplocationmasterid:`${userInfo.pickuplocationmasterid}`,
      
      // };
      var chkmobileVal = this.chkmobileVal();
      if (chkmobileVal) {

        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
     if (this.customer.isactive === "1") {
          this.customer.isactive = "1";
        } else {
          this.customer.isactive = "0";
        }
        this.$validator.validateAll().then(result => {
         
          if (result) {
      
            this.$http
              .post(
                `${ CONSTANTS.MIGRATION_API_URL}/systemusermasteradd`,this.customer).then(result => {
                   document.getElementById("overlay").style.display = "none";
                  if(result.body.returnmsg == 'Successful'){
                      this.$fire({
                        text: "User addedd successfully",
                        type: "success",
                        timer: 30000
                      }); 
                    this.showAddUser = false;
                    
                     this.customer.syspassword ='';
                    this.customer.isactive ='';
                    this.customer.usertype ='';
                    this.customer.countrycode ='';
                    this.customer.pickuplocationmasterid ='';
                    this.customer.sysemailid ='';
                    this.customer.userfirstname ='';
                    this.customer.userlastname ='';
                  }
                  else{
                     this.$fire({
                        text: result.body.returnvalue,
                        type: "error",
                        timer: 30000
                      }); 
                  }
                 this.displaydata();
                  if (this.$route.params.id === 'quick_dashboard') {
                      this.customer.selectedhubtype = 'quick';
                      this.gethublist(this.customer.selectedhubtype);
                    }
                  else{
                    this.gethublist();
                  }
                 
              })
              .catch(ex => {
                console.log("error", ex);
              });
          } else {
            Utils.notify("Correct them errors", "error");
              // this.$fire({
              //     text:"Correct Them", 
              //     type: "error",
              //     timer: 30000
              //   }); 
          }
        });
      } else {
        Utils.notify("Please enter valid mobile number", "error");
         // this.$fire({
         //          text:"Please Enter Valid Mobile Number", 
         //          type: "warning",
         //          timer: 30000
         //        });
      }
    },
     
    clear: function() {
      this.customer = {}
      this.errors.clear('form-1')    
    },


    // change password 
    editAdminPasswordModal: function(value) {
      this.customer.password = value.password;
      this.customer.sysusermasterid = value.sysusermasterid;
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },

    validateForm4(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          console.log("valid password");
          this.changeAdminPassword();
        }
      });
    },

    changeAdminPassword: function() {
      var result = [];
      console.log("1111111111111111")
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      var passwObj = {
        sysusermasterid: `${this.customer.sysusermasterid}`,
        syspassword: `${this.customer.password}`,
        lastmodifiedby: `${userInfo.sysemailid}`
      };

        this.$http
          .post(
            `${CONSTANTS.MIGRATION_API_URL}/changeAdminPassword`,
            passwObj
          )
          .then(result => {
            // alert("Password Updated Successfully");
            this.$fire({
              text: "Password Updated Successfully",
              type: "success",
              timer: 300000
            });
            // this.$alert("Hello Vue Simple Alert.");
            this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
            this.customer = {};
            this.displaydata();
          })
          .catch(ex => {
            console.log("error", ex);
          });
    },

    cancel:function() {
      this.customer = {};
      this.editAgentMastertoggleInfo = !this.editAgentMastertoggleInfo;
    },
    
  }
 
};
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

  .loader {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite;
  /* Safari */
  animation: spin 2s linear infinite;
}
</style>
